export enum LeaderboardGroupType {
  AUDIENCE = 'AUDIENCE',
  LEADERBOARD_GROUP = 'LEADERBOARD_GROUP'
}
